import { useCallback } from "react";
import { useAlert } from "../../../common/Alert";
import { useIntl } from "react-intl";

export function useTodoEditSubmitAlert() {
  const alert = useAlert();
  const intl = useIntl();
  return useCallback(
    (props: {
      title: string;
      onSubmitLater: () => void;
      onSubmit: () => void;
    }) =>
      alert.alert(
        intl.formatMessage(
          {
            defaultMessage: `{todoCategoryTitle} ready to be submitted`,
            description: "TodoEditMain alert title",
          },
          { todoCategoryTitle: props.title }
        ),
        "",
        [
          {
            text: intl.formatMessage({
              defaultMessage: "Submit later",
              description: "TodoEditMain alert button submit later",
            }),

            style: "cancel",
            onPress: () => props.onSubmitLater(),
          },
          {
            text: intl.formatMessage({
              defaultMessage: "Submit",
              description: "TodoEditMain alert button submit",
            }),
            isPreferred: true,

            onPress: () => props.onSubmit(),
          },
        ]
      ),
    [alert, intl]
  );
}
